import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      style={{
        backgroundColor: "#0a0a0a",
        borderTop: "1px solid #333",
        padding: "3rem 2rem",
        marginTop: "4rem",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "3rem",
          marginBottom: "2rem",
        }}
      >
        {/* Contact Info */}
        <div>
          <h3
            style={{
              margin: "0 0 1rem 0",
              fontSize: "0.9rem",
              fontWeight: "700",
              color: "#810100",
              textTransform: "uppercase",
              letterSpacing: "0.1em",
            }}
          >
            Contact
          </h3>
          <ul
            style={{
              listStyle: "none",
              margin: "0",
              padding: "0",
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
            }}
          >
            <li>
              <a
                href="mailto:koyasumiis@gmail.com"
                style={{
                  color: "#999",
                  textDecoration: "none",
                  fontSize: "0.9rem",
                  transition: "color 0.3s ease",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#810100")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#999")}
              >
                koyasumiis@gmail.com
              </a>
            </li>
          </ul>
        </div>

        {/* Follow */}
        <div>
          <h3
            style={{
              margin: "0 0 1rem 0",
              fontSize: "0.9rem",
              fontWeight: "700",
              color: "#810100",
              textTransform: "uppercase",
              letterSpacing: "0.1em",
            }}
          >
            Follow
          </h3>
          <ul
            style={{
              listStyle: "none",
              margin: "0",
              padding: "0",
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
            }}
          >
            <li>
              <a
                href="https://x.com/koyasumii"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#999",
                  textDecoration: "none",
                  fontSize: "0.9rem",
                  transition: "color 0.3s ease",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#810100")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#999")}
              >
                Twitter / X
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/koyasumi"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#999",
                  textDecoration: "none",
                  fontSize: "0.9rem",
                  transition: "color 0.3s ease",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#810100")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#999")}
              >
                Instagram
              </a>
            </li>
          </ul>
        </div>

        {/* Credits */}
        <div>
          <h3
            style={{
              margin: "0 0 1rem 0",
              fontSize: "0.9rem",
              fontWeight: "700",
              color: "#810100",
              textTransform: "uppercase",
              letterSpacing: "0.1em",
            }}
          >
            Credits
          </h3>
          <a
            href="https://github.com/anihab"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              margin: "0",
              fontSize: "0.9rem",
              color: "#999",
              lineHeight: "1.6",
              textDecoration: "none",
              transition: "color 0.3s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#810100")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "#999")}
          >
            Developed by anisa.
          </a>
        </div>
      </div>

      {/* Bottom bar */}
      <div
        style={{
          borderTop: "1px solid #333",
          paddingTop: "2rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "1rem",
        }}
      >
        <p
          style={{
            margin: "0",
            fontSize: "0.85rem",
            color: "#666",
          }}
        >
          © {currentYear} Koyasumi. All rights reserved.
        </p>
        <div
          style={{
            display: "flex",
            gap: "2rem",
            fontSize: "0.85rem",
          }}
        >
        </div>
      </div>
    </footer>
  );
};

export default Footer;
